import React from "react";
import {
  MDBIcon,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol,
  MDBBtn
} from 'mdb-react-ui-kit';

import { Card } from "react-bootstrap";
import CardContent from "@material-ui/core/CardContent";
// import Typography from "@material-ui/core/Typography";



function SavingCardsRow1() {

  return (
    <>
      {/* <div className="row">
        <div className="col">
          <Card
            style={{
              width: '130px',
              height: '96px',
              backgroundColor: "aliceblue",
              boxshadow: 'none !important'
            }}
          >
            <CardContent>
              <Typography className='poppins-font'
                style={{ fontSize: 12 }}
                color="black"
                gutterBottom
              > Total Savings </Typography>
              <Typography className='poppins-font cardnumber'
                style={{ fontSize: '18px', textAlign: 'center', fontweight: "bold", lineheight: ' 2em !important' }}
                color="black"
                gutterBottom
              >
                <label className='poppins-font cardnumber'> $972</label>

              </Typography>
            </CardContent>
          </Card>
        </div>

        <div className="col">
          <Card
            style={{
              width: '130px',
              height: '96px',
              backgroundColor: "aliceblue",
            }}
          >
            <CardContent>
              <Typography className='poppins-font'
               
                gutterBottom
              > On Demand </Typography>
              <Typography className='poppins-font ' >
                 <label className='poppins-font  labelsmallest'> Actual</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label className='poppins-font  labelsmallest'> Potential</label><br/>
                <label className='poppins-font  labelsmallest'> $0</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label className='poppins-font  labelsmallest'> $0</label><br/>
                <label className='poppins-font'  style={{ fontSize: '14px', textAlign: 'center', fontweight: "bold"}}> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$4500</label>

              </Typography>
            </CardContent>
          </Card>
        </div>

        <div className="col">
          <Card
            style={{
              width: '130px',
              height: '96px', 
              backgroundColor: "aliceblue",
            }}
          >
            <CardContent>
            <Typography className='poppins-font'
               
               gutterBottom
              > RI </Typography>
              <Typography className='poppins-font ' >
                 <label className='poppins-font  labelsmallest'> Actual</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label className='poppins-font  labelsmallest'> Potential</label><br/>
                <label className='poppins-font  labelsmallest'> $0</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label className='poppins-font  labelsmallest'> $0</label><br/>
                <label className='poppins-font'  style={{ fontSize: '14px', textAlign: 'center', fontweight: "bold"}}> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$1765</label>

              </Typography>
            </CardContent>
          </Card>
        </div>
        <div className="col">
          <Card
            style={{
              width: '130px',
              height: '96px',
              backgroundColor: "aliceblue",
            }}
          >
            <CardContent>
            <Typography className='poppins-font'
               
               gutterBottom
              > Saving Plan </Typography>
             <Typography className='poppins-font ' >
                 <label className='poppins-font  labelsmallest'> Actual</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label className='poppins-font  labelsmallest'> Potential</label><br/>
                <label className='poppins-font  labelsmallest'> $0</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label className='poppins-font  labelsmallest'> $0</label><br/>
                <label className='poppins-font'  style={{ fontSize: '14px', textAlign: 'center', fontweight: "bold"}}> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$564</label>

              </Typography>
            </CardContent>
          </Card>
        </div>
        <div className="col">
          <Card
            style={{
              width: '130px',
              height: '96px',
              backgroundColor: "aliceblue",
            }}
          >
            <CardContent>
              <Typography className='poppins-font'
               style={{ fontSize: '10px', textAlign: 'center', fontweight: "bold", lineheight: ' 2em !important' }}
              
                color="black"
                gutterBottom
              > Spot </Typography>
              <Typography className='poppins-font ' >
                 <label className='poppins-font  labelsmallest'> Actual</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label className='poppins-font  labelsmallest'> Potential</label><br/>
                <label className='poppins-font  labelsmallest'> $0</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label className='poppins-font  labelsmallest'> $0</label><br/>
                <label className='poppins-font'  style={{ fontSize: '14px', textAlign: 'center', fontweight: "bold"}}> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$0</label>

              </Typography>
            </CardContent>
          </Card>
        </div>
      </div>

 */}

    </>
  )
}
export default SavingCardsRow1